export const colors = {
  PRIMARY: '#FFBC0D',
  SECONDARY: '#FFF',
  BLACK: '#000',
  DUSTYGREY: '#9c9797',
  LIGHTYELLOW: '#ffc107',
  SELECTIVEYELLOW: 'f5ba07',
  DARKGREY: 'rgb(30 30 30)',
  SUNSHINEYELLOW: '#fdd662',
  DASHBOARDGRAPH:'#4E46BE'
};
